import React from "react";
import { useSelectedHexGroupStore } from "@/store/selectedHexGroup";
import { FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { ArrowIcon } from "@/assets/icons";
import { useChooseRegionStore } from "@/store/chooseRegion";
import { useTranslation } from "react-i18next";
import { useServiceType } from "@/utils/hooks/useServiceType";
import classNames from "classnames";
import cls from "./styles.module.scss";

export function ChangeCity() {
  const { t } = useTranslation();
  const { selectedHexGroup } = useSelectedHexGroupStore();
  const { setChooseRegion } = useChooseRegionStore();
  const { isSravniDohod } = useServiceType();

  const reset = () => {
    setChooseRegion(true);
  };

  return (
    <FlexRow
      className={cls.cityWrapper}
      justifyContent="space-between"
      onClick={() => reset()}
    >
      <Typography>{selectedHexGroup?.name ?? t("common.russia")}</Typography>
      <FlexRow gap={4} alignItems="center" className={cls.changeCity}>
        {t("changeCity.selectCity")}
        <div
          className={classNames(
            cls.changeCityIcon,
            isSravniDohod ? cls.changeCityIconSrd : cls.changeCityIconKef
          )}
        >
          <ArrowIcon />
        </div>
      </FlexRow>
    </FlexRow>
  );
}
